<script setup>
import { ref, computed, watch } from 'vue';
import { addDays } from 'date-fns';
import { remoteScript } from '../../libs/http';
import { dateToLocaleDateString, onlyISODate } from '../../libs/dates';
import Overlay from '../../libs/cifra/overlay';

/**
 * OJO!!!!! No funciona bien!!!!! Solo funciona si le pasamos un value y usamos el tema
 * de redirección que tiene el componente.
 * ¡¡¡ No funciona con v-model !!!! Devuelve mal las fechas cuando seleccionas
 * Un componente con un selector de fecha y flechas de siguiente y anterior
 * para avanzar o retroceder entre fechas
 */
const props = defineProps({
  value: { type: String, required: true },
  redirectUrl: { type: String, default: null },
  remote: { type: Boolean, default: false },
  positionDatepicker: { type: String, default: 'bottom left' },
});

const emit = defineEmits(['input']);

const localValue = ref(props.value);
let overlay = null;

const fechaDisplay = computed(() => {
  return dateToLocaleDateString(new Date(localValue.value));
});

const gotoFecha = (avance) => {
  const actual = new Date(localValue.value);
  localValue.value = onlyISODate(addDays(actual, avance));
};

const redirect = (url) => {
  overlay = new Overlay(document.getElementsByTagName('body')[0]);
  overlay.show();
  if (props.remote) {
    remoteScript(url).finally(() => {
      overlay.hide();
    });
  } else {
    window.location = url;
  }
};

watch(
  () => localValue.value,
  (newValue) => {
    emit('input', newValue);
    if (props.redirectUrl) {
      const sep = props.redirectUrl.includes('?') ? '&' : '?';
      const url = `${props.redirectUrl}${sep}fecha=${fechaDisplay.value}`;
      redirect(url);
    }
  },
);

watch(
  () => props.value,
  () => {
    localValue.value = props.value;
  },
);
</script>

<template>
  <div class="input-group ui-desplazador-fecha">
    <a class="btn btn-white input-group-addon" @click="gotoFecha(-1)">
      <i class="far fa-chevron-left"></i>
    </a>
    <input-fecha-hora
      v-model="localValue"
      :icon="false"
      :fixed-width="false"
      :position="positionDatepicker"
    />
    <a class="btn btn-white input-group-addon" @click="gotoFecha(1)">
      <i class="far fa-chevron-right"></i>
    </a>
  </div>
</template>
